
import React, { useState, useEffect } from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Initialize with undefined to prevent hydration mismatch
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    // Check if window is defined (client-side) before using it
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        try {
          setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
        } catch (error) {
          console.error("Error in useIsMobile resize handler:", error)
          // Fallback to false if there's an error
          setIsMobile(false)
        }
      }
      
      // Set initial value with error handling
      try {
        handleResize()
      } catch (error) {
        console.error("Error in useIsMobile initial setup:", error)
        setIsMobile(false)
      }
      
      // Add event listener
      window.addEventListener("resize", handleResize)
      
      // Clean up event listener
      return () => window.removeEventListener("resize", handleResize)
    } else {
      // Server-side or when window is not available
      setIsMobile(false)
    }
    
    return undefined
  }, [])

  // Return false as fallback if isMobile is undefined (e.g., during SSR or errors)
  return isMobile ?? false
}
